export default "__VITE_ASSET__CxS5484P__"